import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';
import { LIST_COUNT_PER_PAGE } from '@common/constants';
import EmptySearch from '@cashier/src/common/components/emptySearch';

import SmartTableMobileListItem from './mobileListItem';

const SmartTableMobile = ({
  data,
  className,
  columnConfig,
  hasPagination,
  countPerPage,
  rowClick,
  mobileExpandable,
}) => {
  const t = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);

  const currentData = useMemo(() => {
    if (!hasPagination) return data;

    return data?.slice(0, currentPage * (countPerPage || LIST_COUNT_PER_PAGE));
  }, [data, currentPage, hasPagination, countPerPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  return (
    <div className={`mobile-smart-table-wrapper ${className || ''}`}>
      <div className="mobile-smart-table-list">
        {data && data.length > 0 ? (
          currentData.map((item, index) => (
            <SmartTableMobileListItem
              // eslint-disable-next-line
              key={index}
              index={index}
              data={item}
              columnConfig={columnConfig}
              rowClick={rowClick}
              expandable={mobileExpandable}
            />
          ))
        ) : (
          <EmptySearch title={t("There is no request yet")} />
        )}
      </div>

      {!!hasPagination && currentData?.length < data?.length && (
        <div className="mobile-smart-table-load-more">
          <button type="button" onClick={() => setCurrentPage(currentPage + 1)}>
            {t('Load more')}
          </button>
        </div>
      )}
    </div>
  );
};

SmartTableMobile.propTypes = {
  hasPagination: PropTypes.bool,
  countPerPage: PropTypes.number,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  columnConfig: PropTypes.array.isRequired,
  rowClick: PropTypes.func,
  mobileExpandable: PropTypes.bool,
};

export default SmartTableMobile;